import React from "react";
import { connect } from "react-redux";
import {enableTool,saveDrawing,setPageData, setPageNotes, copySelectedDrawing, pasteSelectedDrawing,textSelected,selectedObject,grouping, croppingSelectedImage, enablePaintFormatting, selectTool} from '../actions/wizard'
import {wizardActionTypes as ActionTypes} from "../constants";
import PageContainer from "./PageContainer";
import Spinner from "../components/Spinner";
import { debounce } from "helpers/helper";
import {fabric} from 'fabric';
import G from "glob";
import {ReactComponent as LayerIcon} from '../assets/icons/layer.svg'
import { enableLayering } from "../actions/wizard";

class CanvasContainer extends React.Component<any, any>{
     constructor(props){
         super(props);
         this.state={
             notes: ""
         }
     }
    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyPress);
        document.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("mousewheel", this.mouseScroll);
        document.addEventListener("DOMMouseScroll", this.mouseScroll);
        document.addEventListener("mousedown",this.handleSelectedObjects);
        let {pageDetails} = this.props;
        if(pageDetails){
            this.setState({
                notes: pageDetails?.notes
            })
        }
    }
    handleSave = debounce(this.props.saveDrawing,500);
    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        // this.props.fabricInstance.on('object:modified', (options) => {
        //     this.props.saveDrawing();
        // });
        if((prevProps.fabricInstance !==this.props.fabricInstance) ||
            (prevProps.setDrawingStatus !== this.props.setDrawingStatus && this.props.setDrawingStatus ==='success') || ((prevProps.toolEnabled===true || prevProps.toolEnabled===null)&& this.props.toolEnabled ===false)){
            this.props.fabricInstance.on({
                'object:modified':this.handleSave,
                'object:added':  this.handleSave,
                "text:changed":this.handleSave,
                "after:render":this.handleSelect,
                "mouse:over":this.handleMouseIn,
                "mouse:out":this.handleMouseOut,
                "mouse:down":this.handleSelectedObjects,
            });
        }
       if(prevProps.setDrawingStatus !== this.props.setDrawingStatus && this.props.setDrawingStatus ==='pending'){
            this.props.fabricInstance.off({
                'object:modified':this.handleSave,
                'object:added':  this.handleSave,
                "text:changed":this.handleSave,
                "after:render":this.handleSelect,
                "mouse:over":this.handleMouseIn,
                "mouse:out":this.handleMouseOut,
                "mouse:down":this.handleSelectedObjects
            });
        }
    }
    handleSelectedObjects = () => {
        let activeObject = this.props.fabricInstance.getActiveObject();
        if(activeObject!==undefined  && activeObject){
            if(activeObject._objects){
                let activeObjects= [];
                activeObject._objects?.map(ob=>{
                    activeObjects.push(ob);
                });
                this.props.selectedObject(activeObjects);
            }
            else{
                this.props.selectedObject([activeObject]);
            }
            this.handlePaintFormatting(activeObject);
        }
        else{
            this.props.selectedObject([]);
        }
    }

    // Function to handle the paint formatting flow
    handlePaintFormatting = (options: any) => {
        const { paintFormatting, fabricInstance } = this.props
        const canvas = fabricInstance;
        
        // Function to copy text formatting from one text object to another
        function copyTextFormatting(source, target) {
            var propertiesToCopy = [
                'fontFamily', 'fontSize', 'fontWeight', 'fontStyle',
                'fill', 'textAlign', 'lineHeight', 'underline',
                'overline', 'linethrough', 'shadow'
            ];

            propertiesToCopy?.forEach(function (prop) {
                if (source[prop] !== undefined) {
                    target.set(prop, source[prop]);
                }
            });

            canvas.renderAll();
        }

        if (paintFormatting) {
            // If isPaintFormattingEnabled is already selected, apply its formatting to the new selection
            copyTextFormatting(paintFormatting, options);
        }
    }

    handleSelect = () =>{
        let activeObject = this.props.fabricInstance.getActiveObject();
        if(activeObject!==undefined && activeObject){
            if((activeObject.type && activeObject.type==='text')|| (activeObject.type && activeObject.type==='textbox')){
                this.props.textSelected(true);
            }
            else{
                this.props.textSelected(false);
            }
        }
        else{
            this.props.textSelected(false);
        }
    }
   
     handleMouseIn=(e)=>{
         if(this.props.toolEnabled && e.target){
            e.target.selectable=false;
         }
         else if(e.target && e.target.selectable===false){
            e.target.selectable=true;
         }
     }

     handleMouseOut=(e)=>{
        if(e.target){
            e.target.selectable=true;
        }
    }

     handleKeyPress=(e)=>{
         if (e.code==='Escape'){
            // @ts-ignore
            fabric.Canvas.prototype.setCursor= function () {
                let canvasEle = document.querySelector('.upper-canvas');
                 // @ts-ignore
                canvasEle.style.cursor = 'default';
            };
            this.props.enableTool(ActionTypes.DISABLE_TOOL, '', false);
            this.props.enablePaintFormatting(false);
            this.props.selectTool('');
         }
        const keyVal=e.key;
        const activeObject = this.props.fabricInstance.getActiveObject();
        if(activeObject?.type==='textbox' && activeObject?.isEditing && keyVal==='Backspace'){
             this.props.saveDrawing();
        }
        else if(keyVal==='Backspace' || keyVal==='Delete'){
             this.props.enableTool(ActionTypes.DELETE_OBJECT);
             this.props.saveDrawing()
        }

         if ((e?.ctrlKey || e?.metaKey) && e?.key === 'z' && !e?.shiftKey) {
             // Ctrl+Z or Cmd+Z for undo
             const canvas = this.props.fabricInstance;
             canvas.undo();
         } else if (((e?.ctrlKey || e?.metaKey) && e?.key === 'y') || ((e?.ctrlKey || e?.metaKey) && e?.shiftKey && e?.key === 'z')) {
             // Ctrl+Y or Cmd+Shift+Z for redo
             const canvas = this.props.fabricInstance;
             canvas.redo();
         }
        
        if(e.keyCode === 13 && this.props.selectedCropImageDetails.selection) {
            this.props.croppingSelectedImage()
        }
        
    }

    handleKeyDown=(event)=>{
        // To prevent browser based zoom
        // if ((event.ctrlKey==true || event.metaKey==true) && (event.which == '61' || event.which == '107' || event.which == '173' || event.which == '109'  || event.which == '187'  || event.which == '189'  ) ) {
        //     event.preventDefault();
        //  }
        const {selectedObjects} = this.props;
        if(event.shiftKey===true) {
            if(event.code === 'KeyG'){
                if(selectedObjects.length > 0){
                    this.props.grouping(selectedObjects);
                }
                return;
            }
        }
        if((event.ctrlKey===true || event.metaKey===true)) {
            if(event.code === 'KeyC') {
                this.props.copySelectedDrawing();
            } else if(event.code === 'KeyV') {
                this.props.pasteSelectedDrawing();
            }
        }
    }

    mouseScroll=(event)=>{
        // To prevent browser based zoom
        // if (event.ctrlKey == true || event.metaKey==true) {
        //     event.preventDefault();
        // }
    }

    componentWillUnmount(): void {
        document.removeEventListener("keyup", this.handleKeyPress);
        document.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("mousewheel", this.mouseScroll);
        document.removeEventListener("DOMMouseScroll", this.mouseScroll);
        document.removeEventListener("mousedown",this.handleSelectedObjects);
    }

    handleNotesUpdate = (e)=>{
        try {
            let value = e.target.value;
            this.props.setPageNotes({notes: value});
            this.setState({
                notes: value
            })
        } catch (error) {
            console.error("Error in handleNotesUpdate",error);
        }
    }

    handleLayering = () => {
        this.props.enableLayering(!this.props.layeringEnabled);
    }


     render(){
        const {style,exportDrawingStatus,previewMode, pageDetails,uploadStatus,pageLoadingStatus,isDqcDataPresent, uploadingImage} =this.props;
        const {type} = pageDetails || {};
        const className = previewMode==='enabled'?'drawingClassError':'drawingClass';
        const enableLayering = this.props.layeringEnabled && (this.props?.pageDetails?.pageNumber || 1)
        return(
            <React.Fragment>
                {(pageLoadingStatus === true) && <Spinner message="Loading"/>}
                {( (exportDrawingStatus === 'inprogress' && isDqcDataPresent ) || (previewMode === 'enabled')) && <Spinner message="Plan is getting generated. It will take a few minutes..." width={175} />}
                {(uploadStatus === 'pending') && <Spinner message="Please wait while the document is getting uploaded..." width={175} />}
                { uploadingImage && <Spinner message="Please wait while the image is getting uploaded..." width={175} />}
                
             
             <div id={'exportClass'} style={style}>
             
                 <div id={'drawingExport'} className={className}>
                    <div className="layer_tab_btn" style={{ right:enableLayering ? '250px' : 0}} onClick={() => this.handleLayering()}>
                        <i className="fa fa-angle-double-right" aria-hidden="true"   />
                        <p>LAYERS</p>
                    </div>
                    <PageContainer type={type} customerDetails = {this.props.customerDetails} left={style?.left} />
                 </div>
            </div>
            </React.Fragment>

        )
    }

}

export default connect(
    (state: any) => ({
        pageDetails:state.wizard.pageDetails,
        previewMode:state.wizard.previewMode,
        exportDrawingStatus:state.wizard.exportDrawingStatus,
        fabricInstance:state.wizard.fabricInstance,
        setDrawingStatus:state.wizard.setDrawingStatus,
        uploadStatus:state.wizard.uploadStatus,
        pageLoadingStatus: state.wizard.pageLoadingStatus,
        toolEnabled:state.wizard.toolEnabled,
        isDqcDataPresent:state.wizard.isDqcDataPresent,
        colorFontCase:state.wizard.colorFontCase,
        dqcUpdateMode:state.wizard.dqcUpdateMode,
        selectedObjects:state.wizard.selectedObjects,
        layeringEnabled:state.wizard.layeringEnabled,
        selectedCropImageDetails: state.wizard.selectedCropImageDetails,
        paintFormatting: state.wizard.paintFormatting,
        uploadingImage: state.wizard.uploadingImage
    }),
    {
        enableTool,
        saveDrawing,
        setPageData,
        setPageNotes,
        copySelectedDrawing,
        pasteSelectedDrawing,
        textSelected,
        selectedObject,
        grouping,
        enableLayering,
        croppingSelectedImage,
        enablePaintFormatting,
        selectTool
    }
)(CanvasContainer);
